export default {
  deliveryNotes: [],
  deliveryNote: undefined,
};
